import { NgClass, NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ContentChildren,
  ElementRef,
  inject,
  input,
  QueryList,
  signal,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { SvgComponent } from 'icon';
import { MenuItemComponent } from './menu-item/menu-item.component';
import { MenuService } from './menu.service';

let index = 0;

@Component({
  selector: 'lib-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatButtonModule,
    NgClass,
    RouterLink,
    RouterLinkActive,
    NgTemplateOutlet,
    MatMenuModule,
    SvgComponent,
    MatProgressSpinnerModule,
  ],
})
export class MenuComponent {
  private menuService = inject(MenuService);
  public icon = input<string>();
  public iconClass = input<string>('');
  public arrowIconClass = input<string>('');
  public buttonClass = input<string>('');
  public textClass = input<string>('');
  public displayArrow = input(true);
  public label = input('');
  public a11yAltText = input('');
  public loading = input(false);
  public outlined = input(false);
  public collapseOnMobile = input(false);
  public lightTheme = input(false);
  @ContentChildren(MenuItemComponent) public menuItems: QueryList<MenuItemComponent>;
  @ViewChild('menuContent', { read: TemplateRef, static: false }) private menuContent: TemplateRef<unknown>;
  @ViewChild('menuButton', { read: ElementRef }) private menuButton: ElementRef<HTMLElement>;
  public a11yAltTextId = `menu-label-${index++}`;
  public isOpen = signal(false);

  constructor() {
    this.menuService.menuEvents.pipe(takeUntilDestroyed()).subscribe(event => {
      if (!event) {
        this.isOpen.set(false);
      } else if (event.id === this.a11yAltTextId) {
        this.isOpen.set(true);
      }
    });
  }

  public open() {
    this.menuService.open({ template: this.menuContent, positioningElement: this.menuButton, id: this.a11yAltTextId });
  }

  public close() {
    this.menuService.close();
  }
}
